import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class OneClickAlarm {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 列表
  public getOneClickAlarmList(opts: object) {
    const url = serverUrl + '/api/yunnan/oneClickAlarm';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }
  // 新增
  public postOneClickAlarm(opts: object) {
    const url = serverUrl + '/api/yunnan/oneClickAlarm';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 编辑
  public putOneClickAlarm(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/oneClickAlarm/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }
  // 详情
  public detailOneClickAlarm(id: string) {
    const url = serverUrl + `/api/yunnan/oneClickAlarm/${id}`;
    return this.rSerivce.serverObj.get(url);
  }
  // 处置
  public handleOneClickAlarm(id: string, opts: object) {
    const url = serverUrl + `/api/yunnan/oneClickAlarm/handle/${id}`;
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 统计
  // public getOneClickAlarmStatistic(opts: object) {
  public getOneClickAlarmStatistic() {
    const url = serverUrl + '/api/yunnan/oneClickAlarm/statistic';
    return this.rSerivce.serverObj.get(url);
  }
}
